import React, { forwardRef } from "react";

const About = forwardRef((props, ref) => {
  return (
    <section id="about" className="about" ref={ref}>
      <div className="container">
        <h2 className="section-title">About Me</h2>
        <div className="about-content">
          <div className="about-text">
            <p>
              I am a Software Engineering student at COMSATS University Lahore
              with a strong foundation in object-oriented design, Java, JavaFX,
              C++, and data structures. Through academic and internship
              projects, I have built desktop applications, automation-focused
              tools, and systems designed around clear, maintainable logic.
            </p>
            <p>
              More recently, I have expanded into modern web development with
              React and TypeScript. I work with Vite, Chakra UI, React Query,
              Zustand, Axios, and REST APIs to create responsive experiences
              with thoughtful state management. My Game Hub project reflects
              this direction: a searchable, filterable game browser that
              combines API integration with a polished user interface. I am
              always looking for opportunities to solve meaningful problems,
              learn quickly, and contribute dependable software to a
              collaborative team.
            </p>
            <div className="about-stats">
              <div className="stat">
                <span className="stat-number">8+</span>
                <span className="stat-label">Projects Completed</span>
              </div>
              <div className="stat">
                <span className="stat-number">3.5+</span>
                <span className="stat-label">Current CGPA</span>
              </div>
              <div className="stat">
                <span className="stat-number">100%</span>
                <span className="stat-label">Onsite Availability</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
});

export default About;
